<template>
  <div>
    <md-field
      :class="[
        { 'md-valid': !errors.has(name) && touched },
        { 'md-error': errors.has(name) }
      ]"
    >
      <label>{{ $t(label) }}</label>
      <md-input
        v-if="mask"
        v-mask="mask"
        v-validate="validationRules"
        v-model="inputValue"
        :id="name"
        :type="type"
        :name="name"
        :data-vv-name="name"
        :disabled="disabled"
        @input="updateValue"
      />
      <md-input
        v-else
        v-validate="validationRules"
        v-model="inputValue"
        :id="name"
        :type="type"
        :name="name"
        :data-vv-name="name"
        :disabled="disabled"
        @input="updateValue"
      />
      <slide-y-down-transition>
        <md-icon class="error" v-show="errors.has(name)">
          close
        </md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!errors.has(name) && touched">
          done
        </md-icon>
      </slide-y-down-transition>
    </md-field>
    <p v-if="errors.has(name)" class="text-danger">
      {{ errors.first(name) }}
    </p>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  components: { SlideYDownTransition },
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text"
    },
    validationRules: [String, Object],
    mask: String,
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      inputValue: this.value || "",
      touched: false
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
      this.touched = true;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.inputValue);
    }
  },
  inject: {
    $validator: "$validator"
  }
};
</script>
